
import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import { PaymentsFilter, PaymentsTabs } from './ReferrerPayment';
import { useReferrerPayments } from '@/hooks/referrer-payments/useReferrerPayments';
import PaymentHeader from './ReferrerPayment/sections/PaymentHeader';
import BiweeklyPaymentSection from './ReferrerPayment/sections/BiweeklyPaymentSection';

const ReferrerPaymentManagement: React.FC = () => {
  const { toast } = useToast();
  const {
    paginatedPayments,
    filters,
    pagination,
    setSearchQuery,
    setPaymentMethod,
    setDateRange,
    setActiveTab,
    setPage,
    handleApprovePayment,
    handleRejectPayment,
    generateBiweeklyPaymentReport
  } = useReferrerPayments();
  
  const [showBiweeklyReport, setShowBiweeklyReport] = useState(false);
  const biweeklyReport = generateBiweeklyPaymentReport();
  
  const handleGeneratePaymentReport = () => {
    toast({
      title: "Report Generated",
      description: "Payment report has been generated and can be exported."
    });
  };
  
  const handleExportReport = (format: 'csv' | 'pdf') => {
    toast({
      title: `Report Exported as ${format.toUpperCase()}`,
      description: "The report has been downloaded to your computer."
    });
  };
  
  const handleMarkAllAsPaid = () => {
    toast({
      title: "Bulk Payment Processed",
      description: "All pending payments have been marked as paid."
    });
  };
  
  const handleMarkAsPaid = (id: string, amount: number, paidBy: string) => {
    toast({
      title: "Payment Marked as Paid",
      description: `Payment of $${amount.toFixed(2)} has been marked as paid.`
    });
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardContent className="pt-6">
          <PaymentHeader 
            showBiweeklyReport={showBiweeklyReport}
            onToggleReport={() => setShowBiweeklyReport(prev => !prev)}
            onGenerateReport={handleGeneratePaymentReport}
            onExportReport={handleExportReport}
          />
          
          {showBiweeklyReport ? (
            <BiweeklyPaymentSection 
              biweeklyReport={biweeklyReport}
              onMarkAllAsPaid={handleMarkAllAsPaid}
              onMarkAsPaid={handleMarkAsPaid}
            />
          ) : (
            <div className="space-y-6">
              <PaymentsFilter 
                searchQuery={filters.searchQuery}
                setSearchQuery={setSearchQuery}
                paymentMethod={filters.paymentMethod}
                setPaymentMethod={setPaymentMethod}
                dateRange={filters.dateRange}
                setDateRange={setDateRange}
              />
              
              <PaymentsTabs
                activeTab={filters.activeTab}
                setActiveTab={setActiveTab}
                paginatedPayments={paginatedPayments}
                onApprovePayment={handleApprovePayment}
                onRejectPayment={handleRejectPayment}
                isAdmin={true}
                pagination={pagination}
                onPageChange={setPage}
              />
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ReferrerPaymentManagement;
